import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingPlaceholder = _resolveComponent("LoadingPlaceholder")

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent($options.component), {
        key: $options.generateKey(item),
        checked: $setup.selectedParticipants,
        "onUpdate:checked": _cache[0] || (_cache[0] = $event => (($setup.selectedParticipants) = $event)),
        participant: item,
        "show-user-status": $options.showUserStatus,
        onClickParticipant: $options.handleClickParticipant
      }, null, 40, ["checked", "participant", "show-user-status", "onClickParticipant"]))
    }), 128)),
    ($props.loading)
      ? (_openBlock(), _createBlock(_component_LoadingPlaceholder, {
          key: 0,
          type: "participants",
          count: $options.dummyParticipants
        }, null, 8, ["count"]))
      : _createCommentVNode("", true)
  ]))
}